var Cart = function (args) {
  this.init.apply(this, args);
};

Cart.prototype.init = function () {
  var self = this;

  this.$cartIndicator = $(".js-cart-count");
  this.cartPath = "/cart";

  $(window).on('click', () => {
    $('.cart-notification').fadeOut();
    self.closeCart();
  })

  $(document).mouseup(function(e)
    {
      var container = $(".site-cart");
      var closeAnnouncementButton = $('.close-announcement');
      if (closeAnnouncementButton.is(e.target)) {
        return;
      }
    });

  $('.cart-link, .btn-view-basket').on('click', e => {
    e.preventDefault();
    e.stopPropagation();
    self.hideNotification();
    self.openCart();
  });

  $('.log-in-sign-up .sign-up').click(function (e) {
    e.preventDefault();
    $('.sign-up-header').trigger('click');
  });

  $('.log-in-sign-up .login').click(function (e) {
    e.preventDefault();
    $('.login-header').trigger('click');
  });

  var handleAddProduct = function (a) {
    a.preventDefault();
    a.stopPropagation();

    var b = $(this),
      c = b.find('[name="id"]');
    if (c.val()) {
      var formData = self.serializeFormData($(this).serializeArray());

      self.disableCartButton(),
        $.post("/cart/add.js", $(this).serialize(), function (a) {
          self.updateRenderedCart(),
            window._fbq = window._fbq || [],
            window._fbq.push(["track", "AddToCart"]);

          var quantity = formData.quantity;
          self.showNotification(quantity);

          if (a) {
            $('.cart-icon.filled').removeClass('hidden');
            $('.cart-icon.empty').addClass('hidden');
          }
        }, "json").fail(function () {
          $(this).off("submit").trigger("submit");
        });
    } else {
      var d = b.find(".js-variant-selector");

      d.addClass("animated bounce").before(d.clone(!0)),
        d.remove();
    }
  };

  $('body').delegate('form[action="/cart/add"]', 'submit', handleAddProduct);
  $('form[action="/cart/add"]').on("submit", handleAddProduct);

  var variantImageSwap = function () {
    var a, b, c = $('form[action="/cart/add"]'),
      d = c.find('[name="id"]'),
      e = d.find("option"),
      f = d.val();
    f && (a = e.filter("[value=" + f + "]"),
      b = a.data("image"),
      e.each(function () {
        var a = $(this).data("image"),
          c = $('.product__image img[src="' + a + '"]');
        a == b ? c.show() : c.hide()
      }))
  };

  $(".js-variant-selector").on("click", function (a) {
    a.preventDefault(),
      $(this).find(".product__variants").slideToggle(333);
  });

  $(".js-variant").on("click", function (a) {
    a.preventDefault();
    var b = $(this),
      c = b.closest('form[action="/cart/add"]'),
      d = c.find('[name="id"]'),
      e = b.data("variant-id"),
      f = b.data("variant-price"),
      g = b.data("variant-low-inventory"),
      h = d.find("option[value=" + e + "]"),
      i = h.text(),
      j = c.next(".product__low");
    h.prop("selected", !0),
      variantImageSwap(),
      f && b.closest(".product").find(".product__price").text(f),
      b.closest(".js-variant-selector").removeClass("btn--blue").find("span").text(i),
      c.find(".btn:last-child").removeClass("btn--silver").addClass("btn--blue"),
      g ? j.length ? j.text("Only " + g + " left in stock") : c.after('<p class="product__low">Only ' + g + " left in stock</p>") : j.length && j.remove()
  });

  $(".site-cart, .cart").on("click", ".remove-cart-item", function (e) {
    e.preventDefault();
		e.stopPropagation();

    var item = $(this).data("item"),
      qty = $(this).data("qty"),
      line = $(this).data("line");

    $.post("/cart/change.js", {
      quantity: qty,
      line: line
    }, function (a) {
      self.updateRenderedCart();

      if (a.items.length == 0) {
        $('.cart-icon.filled').addClass('hidden');
        $('.cart-icon.empty').removeClass('hidden');
        $('.cart-footer').empty();
        $('.site-cart').addClass('empty-cart');
      }
    }, "json").fail(function () {
      window.location.href = self.cartPath;
    })
  });

  $(".site-cart, .cart").on("click", ".js-qty-btn", function (a) {
    if (a.preventDefault(), !$(this).prop("disabled")) {
      var item = $(this).data("item"),
        qty = $(this).data("qty"),
        line = $(this).data("line");

      $(this).hasClass("js-qty-btn-inc") ? qty++ : qty--, self.changeQty(a, line, qty);
    }
  }).on("keyup", 'input[name="updates[]"]', function (a) {
    var b = $(this),
      c = b.attr("id").replace(/^updates_/, ""),
      d = b.val();
    self.changeQty(a, c, d);
  }).on("focus", 'input[name="updates[]"]', function (a) {
    $(this).on("mousewheel.numbers", function (a) {
      a.preventDefault();
    })
  }).on("blur", 'input[name="updates[]"]', function (a) {
    $(this).off("mousewheel.numbers");
  });

  $(".site-cart, .cart").on("submit", "form#checkout", function () {
    window._fbq = window._fbq || [],
      window._fbq.push(["track", "StartCheckout"]);
  });
};

Cart.prototype.renderCart = function (data) {
  var template = $("#site-cart__template"),
    container = $(".site-cart__inner"),
    footerCartContainer = $('.site-cart .cart-footer'),
    totalCartTemplate = $('#totalCartTemplate');

  if (template.length && container.length) {
    _.templateSettings = {
      evaluate: /<%([\s\S]+?)%>/g,
      interpolate: /<%=([\s\S]+?)%>/g,
      escape: /<%-([\s\S]+?)%>/g
    };

    var compiled = _.template($.trim(template.text())),
      ele = $(compiled(data));
    container.html(ele);

    var compiledTotalCart = _.template($.trim(totalCartTemplate.text())),
      totalEle = $(compiledTotalCart(data));

    footerCartContainer.html(totalEle);
  }
};

var updateProductActionBoxInProductCard = (variantId, quantity) => {
  const quantityElement = $(`#product-quantity-${variantId}`);
  quantityElement.text(quantity);
  var visibility = quantity > 0 ? 'visible' : 'hidden';
  $(`#remove-btn-${variantId}`).css('visibility', visibility);
  $(`#product-quantity-wrapper-${variantId}`).css('visibility', visibility);
}

var changeCartIcon = (cartItemCount) => {
  if (cartItemCount > 0) {
    $('.cart-icon.filled').removeClass('hidden');
    $('.cart-icon.empty').addClass('hidden');
  } else {
    $('.cart-icon.empty').removeClass('hidden');
    $('.cart-icon.filled').addClass('hidden');
  }
}

var findCartItem = (cart, variantId) => {
  return cart.items.find(item => item.variant_id == variantId)
}

var onCartChange = (newCart) => {
  if (window.cart && newCart) {
    var oldCart = cart;
    var oldItemCount = oldCart.item_count;
    var newItemCount = newCart.item_count;
    if (oldItemCount != newItemCount) {
      const items = (oldItemCount > newItemCount) ? oldCart.items : newCart.items
      items.map(item => {
        var oldCartItem = findCartItem(oldCart, item.variant_id);
        var newCartItem = findCartItem(newCart, item.variant_id)
        if (!newCartItem) {
          updateProductActionBoxInProductCard(oldCartItem.variant_id, 0);
        } else {
          updateProductActionBoxInProductCard(newCartItem.variant_id, newCartItem.quantity);
        }
        changeCartIcon(newItemCount);
      })
    }
  }
  cart = newCart
}

Cart.prototype.updateRenderedCart = function (a) {
  var self = this;
  $.get("/cart.js", function (b) {
    onCartChange(b);
    if (b.item_count > 0) {
      var giftcardOffsetPrice = 0;
      self.$cartIndicator.text(b.item_count);
      var isMixedCart = false;
      for (var c = 0; c < b.items.length; c++) {
        b.items[c]['line_price_spark'] = null;
        b.items[c]['price_spark'] = null;
        if (window.isVipMember && !b.items[c].gift_card) {
          var discount = window.DISCOUNT_PERCENT;
          b.items[c]['line_price_spark'] = Math.round((b.items[c].line_price * (1 - discount / 100))).toString().replace(/(.{2})$/, ".$1").replace(/\.00$/, "");
          b.items[c]['price_spark'] = (b.items[c].price * (1 - discount / 100)).toString().replace(/(.{2})$/, ".$1").replace(/\.00$/, "");
        }

        if (window.isVipMember && b.items[c].gift_card) {
          var discount = window.DISCOUNT_PERCENT;
          giftcardOffsetPrice += b.items[c].line_price * (discount / 100);
        }

        b.items[c].image && (b.items[c].image = b.items[c].image.replace(/.jpg/, "_compact.jpg")),
          b.items[c].line_price &&
          (b.items[c].line_price = b.items[c].line_price.toString().replace(/(.{2})$/, ".$1").replace(/\.00$/, "")) &&
          (b.items[c].price = b.items[c].price.toString().replace(/(.{2})$/, ".$1").replace(/\.00$/, ""));

        if (b.items[c]['properties'] && b.items[c]['properties']['frequency_num'] && b.items[c]['properties']['frequency_type_text'] && !isMixedCart) {
          isMixedCart = true;
        }
      }

      window.mixed_cart = isMixedCart;

      b['total_price_spark'] = null;

      var discount = window.DISCOUNT_PERCENT;
      b['total_price_spark'] = Math.round(((b.total_price) * (1 - discount / 100)) + giftcardOffsetPrice).toString().replace(/(.{2})$/, ".$1").replace(/\.00$/, "").replace("..", ".");

      b.total_price = b.total_price.toString().replace(/(.{2})$/, ".$1").replace(/\.00$/, "")

      if (b.item_count == 1) {
        $('.number-cart-item').text('(1 item)');
      } else {
        $('.number-cart-item').text('(' + b.item_count + ' items)');
      }

      $('.site-cart').removeClass('empty-cart');
      $('.spark-message').show();
      $('.site-cart .advertising').removeClass('hide');
    } else {
      self.$cartIndicator.text(0);
      $('.number-cart-item').text('');
      $('.spark-message').hide();
      $('.cart-footer').empty();
      $('.site-cart').addClass('empty-cart');
      $('.site-cart .advertising').addClass('hide');
    }

    self.renderCart(b),
      "undefined" != typeof Shopify.Cart &&
      "undefined" != typeof Shopify.Cart.ShippingCalculator &&
      Shopify.Cart.ShippingCalculator.getRates(),
      self.enableCartButton(),
      a && self.openCart();

    var siteCartEmpty = $('.site-cart__empty');
    if(siteCartEmpty.length != 0) {
      var siteCart = $('.site-cart'),
        siteCartHeight = siteCart.height(),
        half = (siteCartHeight / 2) - siteCartEmpty.height() - 56;

      siteCartEmpty.css({'margin-top' : half});
    }
  }, "json").fail(function () {
    window.location.href = self.cartPath;
  });
};

Cart.prototype.changeQty = function (e, a, b) {
	e.stopPropagation();
  var self = this;
  $.post("/cart/change.js", {
    quantity: b,
    line: a
  }, function (a) {
    self.updateRenderedCart();
  }, "json").fail(function () {
    window.location.href = self.cartPath;
  })
};

Cart.prototype.disableCartButton = function () {};
Cart.prototype.enableCartButton = function () {};

Cart.prototype.openCart = function () {
  $('html').toggleClass('cart-active');
  $('#oos-popup').removeClass('active');
};

Cart.prototype.closeCart = () => {
  $('html').removeClass('cart-active');
}

Cart.prototype.showNotification = function (quantity) {
  var self = this;
  $('.notification-cart-item').text(quantity > 1 ? (quantity + " items") : quantity + " item");

  self.hideNotification();
  var isMobile = $(window).width() <= 768;
  if (isMobile) {
    $('.mobile-cart-notification').slideDown();
  } else {
    $('.cart-notification').fadeIn();
  }
  setTimeout(function () {
    self.hideNotification();
  }, 3000);
};

Cart.prototype.hideNotification = function () {
  var isMobile = $(window).width() <= 768;
  if (isMobile) {
    $('.mobile-cart-notification').slideUp();
  } else {
    $('.cart-notification').fadeOut();
  }
}

Cart.prototype.serializeFormData = function (formArray) {
  var returnArray = {};
  for (var i = 0; i < formArray.length; i++) {
    returnArray[formArray[i]['name']] = formArray[i]['value'];
  }
  return returnArray;
};

$(function () {
  var cartJS = new Cart();
  cartJS.updateRenderedCart();
  window.CartJS = cartJS;
});
